import React from "react"
import { Container, Row, Col } from "react-bootstrap"
import { graphql, useStaticQuery, Link } from "gatsby"
import parser from "html-react-parser"
import * as styles from "./ExploreMill.module.css"
import { StaticImage } from "gatsby-plugin-image"

const ExploreMission = ({ background = {}, title = "" }) => {
  const staticData = useStaticQuery(graphql`
    query {
      wp {
        aCFGlobalOptions {
          aCFexploreContactSection {
            exploreContactText
            exploreContactTitle
            exploreBgImage {
              node {
                localFile {
                  publicURL
                }
              }
            }
            readAboutUsUrl {
              url
            }
            ctaFirstLabel
            ctaSecondUrl {
              url
            }
            ctaSecondLabel
            ctaThirdUrl {
              url
            }
            ctaThirdLabel
          }
        }
      }
    }
  `)

  const data = staticData?.wp?.aCFGlobalOptions?.aCFexploreContactSection
  const bckgImage = background?.node?.localFile?.publicURL
    ? background?.node?.localFile?.publicURL
    : data?.exploreBgImage?.node?.localFile?.publicURL
  const mainTitle = title ? title : data?.exploreContactTitle;
  return (
    <div className="explore-mill-wrap">
      <Container>
        <Row>
          <Col md={12}>
            <div
              className="explore-inner-sec explore-inner-sec-1"
              style={{
                background: `url(${bckgImage}) center top no-repeat`,
              }}
            >
              <Row>
                <Col md={5}>
                  {data.exploreContactText && (
                    <p>{parser(data.exploreContactText)}</p>
                  )}
                  {data.exploreContactTitle && (
                    <h2 className={`${styles.title} about-article-heading mt-0`}>
                      {parser(mainTitle)}
                    </h2>
                  )}
                  {data.readAboutUsUrl && data.ctaFirstLabel && (
                    <Link
                      to={data?.readAboutUsUrl?.url}
                      className="btn white-btn"
                      aria-label="Read about us link"
                    >
                      <StaticImage
                        src="../../../images/next-arrow.png"
                        className={`${styles.arrow} ar-23`}
                        alt="Next"
                      />{" "}
                      {data.ctaFirstLabel}
                    </Link>
                  )}
                  {data.ctaSecondUrl && data.ctaSecondLabel && (
                    <Link
                      to={data?.ctaSecondUrl?.url}
                      className="btn white-btn"
                      aria-label="Second CTA link"
                    >
                      <StaticImage
                        src="../../../images/next-arrow.png"
                        className={`${styles.arrow} ar-23`}
                        alt="Next"
                      />{" "}
                      {data.ctaSecondLabel}
                    </Link>
                  )}
                  {data.ctaThirdUrl && data.ctaThirdLabel && (
                    <Link
                      to={data?.ctaThirdUrl?.url}
                      className="btn white-btn"
                      aria-label="Third CTA link"
                    >
                      <StaticImage
                        src="../../../images/next-arrow.png"
                        className={`${styles.arrow} ar-23`}
                        alt="Next"
                      />{" "}
                      {data.ctaThirdLabel}
                    </Link>
                  )}
                </Col>
                <Col md={7}>
                  <StaticImage
                    src="../../../images/logo.webp"
                    alt="Logo"
                    className="explore-inner-rt-img"
                    placeholder="blurred"
                  />
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default ExploreMission
